// Export all edge components
export { default as ConditionalEdge } from './ConditionalEdge';
export { default as DataFlowEdge } from './DataFlowEdge';
export { default as ErrorEdge } from './ErrorEdge';

// Edge types map for ReactFlow
import { EdgeTypes } from 'reactflow';
import ConditionalEdge from './ConditionalEdge';
import DataFlowEdge from './DataFlowEdge';
import ErrorEdge from './ErrorEdge';

export const edgeTypes: EdgeTypes = {
  conditional: ConditionalEdge,
  dataFlow: DataFlowEdge,
  error: ErrorEdge,
};

